export default __webpack_public_path__ + "static/media/school_kid_2.ff969795.jpg";